import { useState, useMemo } from "react"
import { Row, Col, Input, Tabs, Form, Button ,jsonToQueryString} from "../ui/ot"
import { LibraryTable } from '../koha/views/library'
const LibraryOpenHourManagement = ({

}) => {
    const customFormItems = (propsField) => {
        return (<Row>
            <Col span={24}>
                <Form.List
                    name={[propsField?.name ?? '', "library_space_management_data"]}
                >
                    {(fields, { add, remove }) => (<>
                        <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'end' }}>
                            {fields?.map((field, key) => (<>
                                <Col span={24}>
                                    <Form.Item
                                        hidden={true}
                                        name={[field?.name ?? '', "id"]}
                                    >
                                        <div></div>
                                    </Form.Item>

                                </Col>
                            </>))}

                        </Row>

                    </>
                    )}
                </Form.List>
            </Col>
        </Row>)
    }
    const customColumns = [
        {
            title: "開閉館設定",
            key: "library_space_management_data",
            dataIndex: "library_space_management_data",
            align: "center",
            render: (text, record, index) => {
                let library_space_management_data = record?.library_space_management_data || []
                let library_space_management_first = library_space_management_data?.find((e) => true)
                let space_management_position_data = library_space_management_first?.space_management_position_data || []
                let space_management_position_first = space_management_position_data?.find((e) => true)
                let space_management_position_data_in = space_management_position_first?.space_management_position_data || []
                let space_management_position_in_first = space_management_position_data_in?.find((e) => true)
                let space_management_schedule_data = space_management_position_in_first?.space_management_schedule_data || []
                let space_management_schedule_first = space_management_schedule_data?.find((e) => true)
                let schedule_id = space_management_schedule_first?.schedule_id
                const queryString = jsonToQueryString({
                    schedule_id: schedule_id
                })
                if (schedule_id) {
                    return <Row gutter={[4, 4]} jusify="center">
                        <Col>
                            <Button onClick={() => window.open(`./week_management?${queryString}`, '_blank')} >
                                開館時間設定
                            </Button>
                        </Col>
                        <Col>
                            <Button onClick={() => window.open(`./holiday_management?${queryString}`, '_blank')}  >
                                年度假日設定
                            </Button>
                        </Col>
                    </Row>
                }
                else {
                    return <></>
                }

            }
        },
    ]
    return (<Row>
        <Col span={24}>
            <LibraryTable
                permission_level={1}
                apiRoute="/afats/backend/library"
                propsInitialValues={{
                    library_space_management_data: [
                        {
                            "space_management_position_data": [
                                {
                                    "space_management_position_data": [
                                        {
                                            "space_management_schedule_data": [
                                                {}
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }}
                customColumns={customColumns}
                customFormItems={(fieldName, formValues, onValuesChange, propsCustomForm, field, onFormFinish) => {
                    return customFormItems(field)
                }}
                toolBarRender={(tool) => {
                    return tool
                }}
            />
        </Col>
    </Row>)
}
export default LibraryOpenHourManagement